var _polygon, _polygon2, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.1,313.15l13.35-.27,6.58-.12c2.19,0,4.37,0,6.55-.05l-.45.44L442.08,302l.5.49-13.24-.06c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.53c0-1.87-.11-3.76-.13-5.65v-.27h.28c4.41-.05,8.82-.16,13.24-.16l13.24-.06h.5V302L443,313.15v.45h-.44c-2.23,0-4.47,0-6.7-.05l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.87,327.26l13.35-.27,6.58-.12c2.19,0,4.37,0,6.55-.05l-.45.44,0-11.18.5.49-13.24-.06c-4.41,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.08,3.67-.13,5.53Zm0,0-.14-5.53c-.05-1.87-.12-3.76-.13-5.65v-.27h.28c4.41-.05,8.83-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.18v.45h-.44c-2.23,0-4.47,0-6.7,0l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.18,121l13.35-.28,6.58-.11c2.19,0,4.36,0,6.55-.06l-.45.45,0-11.19.5.5-13.24-.06c-4.42,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.15-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.28c4.41-.06,8.82-.16,13.24-.17l13.24-.06h.5v.5L264.1,121v.45h-.44c-2.24,0-4.47,0-6.7-.05l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,135.07l13.35-.28,6.58-.11c2.19-.05,4.37,0,6.55-.06l-.45.45-.05-11.19.5.5-13.24-.06c-4.42,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.86-.11-3.75-.13-5.65v-.27H252c4.41-.06,8.82-.16,13.24-.17l13.24-.06h.5v.5l-.06,11.19v.45h-.44c-2.23,0-4.47,0-6.7,0l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.66,121l13.36-.28,6.58-.11c2.18,0,4.36,0,6.54-.06l-.44.45-.06-11.19.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.28c4.41-.06,8.83-.16,13.24-.17l13.24-.06h.5v.5L293.59,121v.45h-.44c-2.23,0-4.47,0-6.69-.05l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.33,332.53l13.36-.28,6.58-.12c2.19,0,4.36,0,6.54-.05l-.44.44-.06-11.18.5.49-13.24-.06c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.14,5.53Zm0,0L52.19,327c0-1.87-.11-3.76-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.16l13.24-.06h.5v.51l0,11.18V333h-.45c-2.23,0-4.47,0-6.69-.05l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.42,72.8l13.36-.28,6.58-.11c2.19,0,4.36,0,6.54-.06l-.44.45L83.4,61.61l.5.5L70.66,62c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.14,5.53Zm0,0-.14-5.54c0-1.87-.11-3.75-.13-5.65v-.27h.27c4.42,0,8.83-.15,13.24-.16l13.24-.06h.51v.5L84.35,72.8v.45H83.9c-2.23,0-4.47,0-6.69,0l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.65,86.91,56,86.63l6.58-.11c2.18,0,4.36,0,6.54-.06l-.44.45-.06-11.19.5.5-13.24-.07c-4.41,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.08,3.67-.13,5.53Zm0,0-.14-5.54c0-1.87-.11-3.75-.13-5.65v-.27h.27c4.41,0,8.83-.15,13.24-.16l13.24-.06h.5v.5l0,11.19v.45h-.45c-2.23,0-4.47,0-6.69,0l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.8,72.8l13.35-.28,6.58-.11c2.19,0,4.36,0,6.55-.06l-.45.45-.05-11.19.5.5L423,62c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.15-5.54c0-1.87-.11-3.75-.13-5.65v-.27h.28c4.41,0,8.82-.15,13.24-.16l13.24-.06h.5v.5l-.06,11.19v.45h-.44c-2.24,0-4.47,0-6.7,0l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.75,
    y: 81.23,
    width: 59.11,
    height: 38.59,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.75,
    y: 122.09,
    width: 59.11,
    height: 38.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.55,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.49,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.43,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.38,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.32,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.27,
    y: 129.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.55,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.49,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.43,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.38,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.32,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.27,
    y: 136.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.55,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.49,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.43,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.38,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.32,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.27,
    y: 143.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.55,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.49,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.43,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.38,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.32,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.27,
    y: 150.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.29,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.52,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.74,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.96,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.19,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.41,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.63,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.86,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.08,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.3,
    y: 117.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.31,
    cy: 85.18,
    r: 0.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.87,44.16H218v208H58.87Zm155,4.19H63.06V248H213.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.98,
    y: 49.45,
    width: 4.2,
    height: 200.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 52.64,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 111.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 59.22,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 124.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 65.79,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 137.42) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 72.36,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 150.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 78.94,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 163.72) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 85.51,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 176.87) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 92.09,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 190.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 98.66,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 203.17) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.06,
    y: 105.24,
    width: 166.76,
    height: 5.84,
    transform: "translate(276.89 216.32) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.53,
    y: 51.46,
    width: 1.05,
    height: 134.7,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.19 191.04 69.91 191.04 68.98 185.69 67.12 185.69 66.19 191.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.75,
    y: 51.46,
    width: 1.05,
    height: 194.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.41 250.25 66.13 250.25 65.2 244.9 63.34 244.9 62.41 250.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 43.34,
    width: 179.79,
    height: 12.23,
    transform: "translate(276.89 98.9) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 225.45,
    width: 92.34,
    height: 171.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.44,
    y: 220.71,
    width: 101.28,
    height: 4.74,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.73,
    y: 220.71,
    width: 31.85,
    height: 4.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.26,
    y: 225.45,
    width: 31.28,
    height: 171.73,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,336.05H340.85v-41h72.47Zm-72.22-.25h72V295.33h-72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.98,
    y: 307.06,
    width: 14.11,
    height: 8.11,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.38,314.68H371v-7.14h14.36Zm-14.11-.25h13.85v-6.64H371.27Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,387.49H340.85v-41h72.47Zm-72.22-.25h72V346.77h-72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.98,
    y: 358.5,
    width: 14.11,
    height: 8.11,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.38,366.12H371V359h14.36Zm-14.11-.25h13.85v-6.63H371.27Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.98,
    y: 243.76,
    width: 72.22,
    height: 40.72,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.18,
    y: 233.33,
    width: 54.98,
    height: 39.85,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.61 229.21 351.18 229.21 351.18 233.33 371.73 233.33 370.61 229.21",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.02 273.19 351.04 273.19 346.8 236.64 401.78 236.64 406.02 273.19",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.79 232.85 346.36 232.85 346.8 236.64 367.34 236.64 365.79 232.85",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.18,
    y: 243.76,
    width: 72.22,
    height: 40.72,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.53,284.6H306.06v-41h72.47Zm-72.22-.25h72V243.88h-72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.18,
    y: 255.61,
    width: 14.11,
    height: 8.11,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.58,263.23H336.23V256.1h14.35Zm-14.1-.25h13.85v-6.63H336.48Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.58,
    y: 249.86,
    width: 34.62,
    height: 34.62,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40.29 397.19 92.72 396.94 145.14 396.85 250 396.69 354.86 396.85 407.28 396.94 459.71 397.19 407.28 397.43 354.86 397.52 250 397.68 145.14 397.52 92.72 397.43 40.29 397.19",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 444.42,
    rx: 204.99,
    ry: 14.92,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.87,88s9.66-5.34,18.25,0,12.68,18.51,11.21,29.57,7.54,18.34,8.51,26.55-4.42,12-6.22,16.32c-2.08,4.93,6.22,22.45-14.89,26.51-26.41,5.08-36.51-11.16-33.82-24.58,1.32-6.58,5-11.25,4.95-16.58S303,136.2,305,129.46s4.56-5.83,5.63-16.43S309.52,89.77,318.87,88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.3,87.72a32.68,32.68,0,0,1,12.48,15,30.25,30.25,0,0,1,2.24,9.61c.27,4.32-.39,8.36,1.22,12.55,2.57,6.71,7.72,12.31,7.47,19.79a18.49,18.49,0,0,1-3.17,9.75c-2.28,3.38-5.53,6-7.44,9.66-.08.15-.32,0-.24-.13,1.59-3.22,4.17-5.67,6.32-8.55a18.78,18.78,0,0,0,3.9-11.75c-.2-7.1-5.28-12.57-7.65-19a22.63,22.63,0,0,1-1-8.84A32.24,32.24,0,0,0,348,105.1a34.48,34.48,0,0,0-12.8-17.29C335.17,87.77,335.24,87.68,335.3,87.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,168.42a0,0,0,0,1,0,.05A0,0,0,0,1,346.41,168.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,160.43c.66-3.17,2.32-6.05,3-9.22.79-3.81-.17-7.61-.9-11.35-1-5.34-.92-10.38,1.44-15.41,1.53-3.25,3.38-6.29,4.51-9.71a39.73,39.73,0,0,0,2-11.47.07.07,0,0,1,.14,0,36.63,36.63,0,0,1-3.53,16.37c-1.44,3-3.24,5.82-4.06,9.06-1,3.89-.61,7.66.07,11.56a44.68,44.68,0,0,1,1,7.89,22,22,0,0,1-1.87,7.78,27.39,27.39,0,0,0,.12,20.15c0,.11-.16.19-.21.08A26,26,0,0,1,302,160.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.55,143.14c-.24-5.85-4.31-9.82-6.79-14.9-1.87-3.83-3.14-7.92-2.52-12.15,0-.07.13,0,.13,0-.32,6.11,2.25,11.66,5.63,16.78,2.25,3.4,4.11,6.67,4.14,10.77s-1.59,7.39-3.87,10.71c-1.63,2.37-3.24,4.58-3.93,7.37a29.76,29.76,0,0,0-.39,8.53c0,.15-.23.15-.25,0-.39-4.38-.45-8.63,1.76-12.63C354.17,152.72,357.79,149.09,357.55,143.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,156.28a36.2,36.2,0,0,1,3.37-5.67c2.24-3.29,2.61-6,1.87-9.87,0-.08.11-.12.14,0,1.08,3.22,1.33,5.89-.58,8.85-2.66,4.14-5.27,7.91-5.82,12.85-1,8.76,4,16.94,12,21.37.11.06,0,.22-.11.16-6.73-3.31-11.45-9.31-12.44-16.39A21.09,21.09,0,0,1,301,156.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,444.22c2.42.78,71.3-.11,73.9-1.81,1-.63,1.45-10.68,1.66-22.83,0-.13,1.14-44.89,1.14-44.89l-44.09.46L317.33,420s-26.21,12.13-28.87,14.3S283.78,443.45,286.19,444.22Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.89,424.75c.18-.06.28-.11.29-.16A3,3,0,0,0,306.89,424.75Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.62,425.34c-.24,9.43-.69,16.54-1.53,17.07-2.6,1.7-71.48,2.59-73.9,1.81s-.38-7.72,2.27-9.88c1.58-1.29,11.46-6.09,19.23-9.77C297.13,430.91,293.28,437.78,361.62,425.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.57,176.28s-11.23,116.66-12.92,125.54c-.39,2-1,114.11-1,114.11l-47-.71s4.58-96.42,6.73-114.16,12.22-124.78,12.22-124.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,406.13a35.41,35.41,0,0,0-4.24-.31c-1.42-.06-2.84-.14-4.25-.19-2.78-.11-5.56-.23-8.35-.33q-8.49-.29-17-.59c-3.19-.12-6.38-.12-9.57-.09a.1.1,0,0,0,0,.19c11.27,1.13,22.65,1.37,34,1.65,1.62,0,3.24.06,4.86.08a35.44,35.44,0,0,0,4.61-.07C361.4,406.45,361.33,406.16,361.16,406.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.22,181.42c-3.43,28.44-6.86,56.9-9.7,85.41-1.41,14.14-2.73,28.3-3.61,42.49s-1.24,28.61-1.43,42.93c-.23,16.19-.61,32.39-.35,48.58,0,.15.23.14.24,0,1.41-28.61,1-57.28,2.52-85.89s4.63-57.13,7.77-85.62c1.77-15.94,3.42-31.89,5.07-47.84C370.76,181.19,370.25,181.13,370.22,181.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,449.61c2.53.2,69.3-16.74,71.43-19,.83-.84-1.07-10.71-3.71-22.58l-.09-.37c-.54-2.44-14.61-43.55-14.61-43.55L392.4,375.27l14.73,42.83.2.73s-22.66,17.91-24.74,20.65S380.17,449.43,382.7,449.61Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.13,430.61c-2.13,2.26-68.9,19.2-71.43,19s-2.17-7.41-.11-10.13c1.14-1.5,8.42-7.53,14.79-12.68-8.92,9.32-12,18,53.9-14.82C453.46,422,454.87,429.87,454.13,430.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,414.76l47.63-11.49s-35.66-92.8-37.67-99c-1.46-4.52-13.28-59.71-17.44-83.82,0,0,6.21-17.6-7.69-44.18H334.53s1.25,25.29,7.64,41.33a74,74,0,0,1,12.4,5.66s15.25,86.31,17.76,94.18C377.76,334.44,403,414.76,403,414.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,269.43q-2.87-15.26-5.72-30.51c-.54-2.87-1.14-5.73-1.73-8.59s-1.11-5.75-1.93-8.53a.17.17,0,0,0-.33.06c.15,2.59.63,5.18,1,7.76s.71,5,1.14,7.51c.88,5.12,1.83,10.23,2.8,15.34,1.94,10.19,3.87,20.43,6.24,30.53,1.34,5.69,2.58,11.4,4,17.07,0,.12.2.06.18-.06C366.89,289.8,365,279.61,363,269.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.82,210.54c.72-1.78.15-3.82-.17-5.62-.42-2.29-.82-4.58-1.24-6.87-1-5.15-2-10.29-3.11-15.42a0,0,0,0,0-.09,0c.5,4.1,1.06,8.19,1.65,12.28s1.39,8.2,1.9,12.33c.16,1.33.05,4-1.88,4-1.63,0-2.62-2.43-3.14-3.64-1.56-3.57-2.19-7.5-3-11.29-.95-4.54-1.72-9.11-2.51-13.67a.14.14,0,0,0-.27,0c.28,4.54.87,9,1.6,13.52.7,4.26,1.36,8.74,3.16,12.71.67,1.49,1.61,3.32,3.33,3.79a3.16,3.16,0,0,0,.74.08c.15,1.37.36,2.72.64,4.06a28.11,28.11,0,0,0,1.08,4.15.17.17,0,0,0,.32-.06h0a29.43,29.43,0,0,0-.63-4.16,36.75,36.75,0,0,0-1-4A3.48,3.48,0,0,0,351.82,210.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,223.85a43,43,0,0,0-8.45-2.8,58.29,58.29,0,0,0-8.5-1.17c-.11,0-.13.18,0,.19,2.84.44,14.1,3.21,16.92,3.91C360.78,224,360.83,223.88,360.75,223.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,369.49q-3.83-10.17-7.66-20.31c-5.06-13.42-10.28-26.79-15.32-40.22-5-13.26-7.11-27.36-9.83-41.24-1.39-7.06-2.75-14.14-4.15-21.21s-3.06-14-3.88-21.11.24-13.9-.37-20.84a52.07,52.07,0,0,0-4.9-17.87,46.28,46.28,0,0,0-2.25-4.16c-.09-.16-.32,0-.24.15a56.39,56.39,0,0,1,6.15,18.63,57,57,0,0,1,.52,9.77c-.09,3.51-.34,7-.17,10.52.33,7,2,13.91,3.3,20.77s2.76,14,4.14,21,2.79,14.13,4.17,21.2A161.42,161.42,0,0,0,404.68,305c2.24,6.68,4.86,13.23,7.35,19.81q3.86,10.15,7.71,20.29c5.16,13.45,10.2,27,15.59,40.31.62,1.56,1.26,3.11,1.94,4.64.09.2.41.05.35-.16C435.43,383,432.76,376.24,430.22,369.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,393.3a37.09,37.09,0,0,0-4.15.93c-1.37.35-2.75.69-4.12,1l-8.08,2.11c-5.48,1.46-10.95,2.93-16.44,4.37-3.08.82-6.14,1.74-9.18,2.69a.1.1,0,0,0,.05.19c11.11-2.19,22.08-5.27,33-8.29,1.56-.43,3.12-.88,4.67-1.33a36.75,36.75,0,0,0,4.39-1.4C445.45,393.53,445.3,393.28,445.12,393.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.34,132.18c-.15,12.63-10.62,41.51-21.79,47.53-9,4.84-35.69,13.29-43.5,13.61-6.58.28-8.89-27.08-3.63-28.23,6.57-1.42,29.43-3.94,34.36-7.57,1.94-1.42,12.62-12.16,25.84-27C337.06,124.42,340.43,124.63,340.34,132.18Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.87,190.43c-2.77,2-16.29,10-20.55,11.38s-16.8,4.49-18.2,1.34,2.21-4.36,2.21-4.36-5.51.47-6.62-2.83,4.55-5,4.55-5-5.69.07-6.56-3.3,5.1-4.12,5.1-4.12-5.2.31-4.75-2.77c.54-3.71,10.19-3.19,14.78-5.08,1-.42,20.5-10.17,20.5-10.17Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29,183.63c7.1.36,10.26-.71,16.36-4.14.12-.06.25.1.13.18-5.67,3.9-9.45,5.81-16.53,4.3C241.91,183.9,242,183.61,242.29,183.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.7,190.93c7.4-.26,10.85-1.39,17.5-4.51.09,0,.18.11.08.16-6.26,3.61-10.08,5.43-17.51,4.72C243.43,191.27,243.36,191,243.7,190.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.66,198.62c7.15-.77,11-1.85,17-5.71a.14.14,0,0,1,.16.22c-5.81,4.53-10.58,5.91-17.16,5.71C246.26,198.82,246.21,198.67,246.66,198.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4,165.87S270,163,266,162.55s-19.43,3.36-18.8,6.74c.82,4.37,10.17,3.93,14.72,3.12,0,0,1.87,10.1,8.65,11.24S278.4,165.87,278.4,165.87Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82,170.42c3.62,3.44,9.52,2,14,1.53a.42.42,0,0,1,.47.49c1.07,4.19,3.79,9.78,8.06,11.37a.1.1,0,0,1-.06.2c-4.81-1.09-7.93-6.36-8.81-11-4.58.55-10.57,1.74-13.69-2.54C247.77,170.43,247.8,170.39,247.82,170.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.71,172.1,315,148.56s8.48-11.95,17.49-20.4S344,130.08,339,146,329.71,172.1,329.71,172.1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.71,172.1,315,148.56s8.48-11.95,17.49-20.4S344,130.08,339,146,329.71,172.1,329.71,172.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.66,165.37c-3-5.22-6.32-10.24-9.76-15.17-1-1.4-2-2.77-3-4.12,0,0-.1,0-.07,0,1.54,2.58,3.19,5.09,4.82,7.61s3.29,5,5,7.52c1,1.4,1.93,2.8,2.92,4.18C331.6,165.48,331.7,165.43,331.66,165.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,146c-5,15.94-9.24,26.08-9.24,26.08l-10.47-16.72,21-29C342.24,129.27,341.88,136.69,339,146Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55,191.29l58.79-11.83S365.51,135.11,350.53,125c-6.82-4.61-12-2.49-15.66,2.31-.91,1.2-10.9,22.23-10.68,28.71.2,5.73,6.05,10.81,6.05,10.81Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1,162.52a43.63,43.63,0,0,1,7.67-.12c1.28.11,2.55.3,3.83.51.63.11,1.26.19,1.9.27a6.64,6.64,0,0,0,2,0c.06,0,.08.1,0,.11a11.39,11.39,0,0,1-1.83.36,11.2,11.2,0,0,1-1.83,0c-1.29-.1-2.59-.27-3.88-.39-2.62-.23-5.23-.46-7.84-.47C338,162.78,338,162.53,338.1,162.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57,166.51a46.21,46.21,0,0,1,6.06-1.69,29.83,29.83,0,0,1,3.11-.44c.5,0,1-.08,1.51-.11s1.11,0,1.66,0c.06,0,.09.1,0,.1-.52.06-1,.23-1.54.32l-1.54.28c-1,.19-2.05.4-3.08.58-2.07.36-4.12.74-6.16,1.18C332.51,166.74,332.47,166.54,332.57,166.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 204.41 343.08 155.38 306.23 175.24 331.58 224.27 368.44 204.41",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.69 192.61 303.87 177.49 306.23 175.24 314.69 191.61 311.69 192.61",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 204.41 343.08 155.38 306.23 175.24 331.58 224.27 368.44 204.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.69 192.61 303.87 177.49 306.23 175.24 314.69 191.61 311.69 192.61"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "368.4 204.33 342.98 155.18 306.33 172.14 331.75 221.28 368.4 204.33",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.4 204.33 342.98 155.18 306.33 172.14 331.75 221.28 368.4 204.33",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,126.86c13.76,10.39,41.83,36.29,37.59,45.08-7,14.46-28.89,31.65-36.06,35.8-3.13,1.81-21.6-19.18-19-22,3.14-3.41,27.38-19.46,26.63-21.71-.42-1.27-6.39-11.24-12.78-24.41C343,124.32,347.45,121.92,354,126.86Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,199.52a4.42,4.42,0,0,0,3.54,3.6,6.55,6.55,0,0,0-.35,4.44c.84,2.57,5.23,2.38,5.23,2.38a8.12,8.12,0,0,0,.38,4.75c1.05,2.38,5.52,2.82,5.52,2.82a7.13,7.13,0,0,0,3,4c3.93,2.31,10.1-.9,14-2.91s13.25-11.37,15.21-13l-12.63-25.43s-20.24,4-24.54,7C317,189.67,310.8,196.1,311.25,199.52Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,202.62c3.21-3.62,7.31-6.1,11.26-8.8.09-.06.18.08.1.14-4,2.64-7.36,6-11.21,8.83C314.81,202.87,314.67,202.72,314.76,202.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.59,209.57a12.15,12.15,0,0,1,2.69-1.91c1-.61,2-1.21,3-1.78q3-1.74,6.18-3.32c.09-.05.19.08.09.14-2,1.15-4,2.34-6,3.58-1,.62-2,1.25-2.95,1.89a15.4,15.4,0,0,1-2.85,1.67A.17.17,0,0,1,319.59,209.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.65,217.46a8.5,8.5,0,0,1,2.51-1.59l2.81-1.54c1.86-1,3.72-2.08,5.55-3.18.09-.05.18.09.09.14-1.85,1.13-3.68,2.28-5.54,3.39-.92.55-1.83,1.09-2.75,1.62a8,8,0,0,1-2.62,1.25A.06.06,0,0,1,325.65,217.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,153.08l-27.63,3s-7-12.84-10.71-24.64,6.75-9.52,18.91,1.94S384.32,153.08,384.32,153.08Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,153.08l-27.63,3s-7-12.84-10.71-24.64,6.75-9.52,18.91,1.94S384.32,153.08,384.32,153.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,155.82c-.15,0-1.14,0-1.14,0-.12-.35-2.5-5.8-3.09-7-1.19-2.4-2.53-4.73-3.84-7.07,0-.07-.16,0-.12.06.92,2,1.81,4.1,2.75,6.13-.23-.27-.47-.55-.69-.83-.46-.58-.88-1.18-1.32-1.78,0,0-.13,0-.1.06a11,11,0,0,0,1.57,2.36,8.83,8.83,0,0,0,.86.87l.23.51c.57,1.18,3.46,7,3.56,7s1-.12,1.33-.17C357.89,156,357.89,155.81,357.81,155.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.11,148.39c-6,.4-12,1.22-17.91,2.15-1.68.27-3.35.57-5,.92-.05,0-.05.08,0,.07,3-.26,6-.65,8.95-1s6-.77,8.95-1.22c1.68-.26,3.36-.51,5-.8C379.19,148.49,379.18,148.38,379.11,148.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,130.18s2.91,7.26,9.48,7.26,13.9-12.29,13.9-12.29-6.6-3.64-12.67-2.73S330.36,130.18,330.36,130.18Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,123.81c.21,1.06-1.54,9.39-6,11.19-1.46.58-5-7.27-5-7.27l-.39-.52-5.5-7.27,6.74-10.43,1-1.44s1.37,2.09,3.05,4.71l.24.38c.1.14.2.28.28.42.26.39.52.78.77,1.19s.38.6.57.92.39.64.58,1A58.81,58.81,0,0,1,345.08,123.81Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,112.78a18.3,18.3,0,0,1-5.3,14.43l-5.5-7.27,6.74-10.43,1-1.44S337.29,110.16,339,112.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.48,110.23c2,15.87,11.76,16.45,15.18,16,3.11-.39,13.63-2.15,13.27-18.14S329.54,88,322.39,88.56,307.47,94.35,309.48,110.23Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,107.2c.36-.1.68-.25,1-.38a1.81,1.81,0,0,0,1-.6.58.58,0,0,0-.1-.69,1.43,1.43,0,0,0-1.43-.12,2.06,2.06,0,0,0-1.17.92A.6.6,0,0,0,311.38,107.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,105.54a10,10,0,0,1-1.1-.06,1.78,1.78,0,0,1-1.11-.28.58.58,0,0,1-.11-.69,1.39,1.39,0,0,1,1.33-.53,2.05,2.05,0,0,1,1.4.53A.61.61,0,0,1,322.22,105.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.29,109.8s.1,0,.1.09c.1,1.08.4,2.31,1.42,2.54,0,0,0,.07,0,.07C320.6,112.48,320.22,110.85,320.29,109.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.12,108.55c1.72-.35,2.29,3.12.7,3.45S319.67,108.85,321.12,108.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83,108.62c.34.15.69.45,1.06.42s.69-.44.91-.84c0,0,.06,0,.06,0,.12.67,0,1.39-.72,1.61s-1.19-.32-1.47-1C321.62,108.76,321.69,108.56,321.83,108.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.28,110.57s-.07.06-.06.1c.22,1.07.29,2.33-.62,2.86,0,0,0,.07,0,.06C314.78,113.21,314.66,111.54,314.28,110.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,109.61c-1.75.17-1.28,3.66.34,3.5S314.6,109.47,313.13,109.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,109.94c-.25.22-.47.59-.8.66s-.71-.27-1-.6c0,0-.06,0-.05,0,.07.67.38,1.33,1,1.38s.95-.6,1-1.28C312.65,110,312.53,109.85,312.43,109.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.88,118.6c-.2.31-.38.71-.76.82a2.9,2.9,0,0,1-1.21,0,0,0,0,0,0,0,.06,1.46,1.46,0,0,0,1.47.29,1.15,1.15,0,0,0,.64-1.12C322,118.57,321.91,118.56,321.88,118.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,117.49a4.44,4.44,0,0,0,1.9,1.21,2,2,0,0,0,1.21,0c.86-.31.81-1.12.58-1.79a4.85,4.85,0,0,0-.48-1A5.75,5.75,0,0,1,317.44,117.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.34,118.7a2,2,0,0,0,1.21,0c.86-.31.81-1.12.58-1.79A2.07,2.07,0,0,0,319.34,118.7Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.78,115.4a23.92,23.92,0,0,0,.14,2.4c0,.08.2.08.46.06h0a3.64,3.64,0,0,0,3.3-1.88.08.08,0,0,0-.13-.09,5.5,5.5,0,0,1-3.15,1.45c-.09-.2.05-2.81-.07-2.81a6.59,6.59,0,0,0-1.66.66c-.15-3.42.24-6.84,0-10.24a.1.1,0,0,0-.2,0,55.16,55.16,0,0,0-.52,11C315,116.39,316.5,115.58,316.78,115.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.7,114a3.59,3.59,0,0,1-.68.34,2.42,2.42,0,0,1-.74.18,2.13,2.13,0,0,1-1-.1,2.6,2.6,0,0,1-.69-.33,3,3,0,0,1-.78-.75l0-4.36s2.36-5.62,4.83-4.88S341.09,112.42,338.7,114Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,106.23a0,0,0,1,1,0,.06c-1.66,1.13-2.25,3-2.55,4.93a1.5,1.5,0,0,1,2.1-.87c.06,0,0,.11,0,.11a1.68,1.68,0,0,0-1.67,1,8.3,8.3,0,0,0-.54,1.64c-.05.18-.36.15-.34,0v0C335.75,110.64,336.85,107,339.29,106.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.34,113.33a.75.75,0,0,1-.73.76.75.75,0,1,1,.73-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.59,111.92a.52.52,0,0,1-.51.53.54.54,0,0,1-.54-.52.53.53,0,0,1,.52-.53A.52.52,0,0,1,339.59,111.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.14,108c-2.56.7-4.13-5.23-4.13-5.23s-5.29,1-8.47-6.25a11.86,11.86,0,0,0,3.53,5.84s-9.57,1.37-15-5.69c0,0,2.32,3.68,4.06,4.81a11.14,11.14,0,0,1-6.63-3.16s-.78,4.81-1.8,6.3c0,0-2.71-16.39,12.73-17.52,0,0,9.59-1.17,14.41,5.67S337.14,108,337.14,108Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Printer--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.06,
    y: 335.08,
    width: 57.56,
    height: 92.8,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.06,
    y: 335.08,
    width: 57.56,
    height: 92.8
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 71.06,
    y: 335.08,
    width: 56.05,
    height: 92.8,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.06 335.08 54.82 335.08 40.45 367.23 44.25 367.23 58.95 343.32 71.06 343.32 71.06 335.08",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.77 383.21 117.77 351.26 127.11 347.26 127.11 387.21 117.77 383.21",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.06,
    y: 343.32,
    width: 56.05,
    height: 1.76,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.43,
    y: 294.37,
    width: 51.29,
    height: 40.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.43,
    y: 294.37,
    width: 51.29,
    height: 40.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.73,
    y: 294.39,
    width: 19.49,
    height: 40.61,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.43 314.67 110.73 314.69 70.67 315.72 59.43 314.67",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.72 330.09 59.43 330.06 99.49 331.13 110.72 330.09",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.44 303.31 91.93 303.33 63.05 304.17 59.44 303.31",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.72 324.11 78.23 324.1 107.11 324.96 110.72 324.11",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.75 298.8 108.39 298.82 102.28 299.33 71.75 298.8",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.42 319.02 101.06 319.04 94.96 319.55 64.42 319.02",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.96 307.19 110.73 307.21 114.98 308.57 86.96 307.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.96 307.19 110.73 307.21 114.98 308.57 86.96 307.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.89 307.18 76.66 307.19 80.91 308.56 52.89 307.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.38 325.44 59.61 325.43 55.36 326.8 83.38 325.44",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.72 320.82 129.81 320.83 134.06 322.2 110.72 320.82",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.39 314.69 132.19 314.7 130.22 313.58 117.39 314.69",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 333.76,
    width: 156.77,
    height: 94.12,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 333.76,
    width: 156.77,
    height: 94.12,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 417.53,
    width: 156.77,
    height: 10.35,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 390.04,
    width: 156.77,
    height: 26.16,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.95 399.39 165.05 399.39 161.05 390.04 212.95 390.04 208.95 399.39",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 362.56,
    width: 156.77,
    height: 26.16,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.95 371.9 165.05 371.9 161.05 362.56 212.95 362.56 208.95 371.9",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 335.08,
    width: 156.77,
    height: 26.16,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.95 344.42 165.05 344.42 161.05 335.08 212.95 335.08 208.95 344.42",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.53,
    y: 240.29,
    width: 51.29,
    height: 40.61,
    transform: "translate(-81.16 144.1) rotate(-24.29)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.53,
    y: 240.29,
    width: 51.29,
    height: 40.61,
    transform: "translate(-81.16 144.1) rotate(-24.29)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.69,
    y: 225.73,
    width: 19.49,
    height: 40.61,
    transform: "translate(-72.31 156.08) rotate(-24.29)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.8 271.14 317.55 250.04 281.47 267.48 270.8 271.14",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.88 264.08 277.13 285.18 314.07 269.65 323.88 264.08",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.13 260.8 295.74 247.43 269.77 260.09 266.13 260.8",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.43 258.63 291.81 272 318.49 260.89 321.43 258.63",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.48 251.62 308.88 236.54 303.53 239.52 275.48 251.62",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.13 273.06 310.53 257.99 305.18 260.96 277.13 273.06",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.8 253 314.47 243.22 318.9 242.72 292.8 253",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.8 253 314.47 243.22 318.9 242.72 292.8 253",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.75 267.02 283.42 257.24 287.85 256.74 261.75 267.02",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.06 271.1 275.39 280.88 272.08 283.88 297.06 271.1",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.07 255.63 337.47 247.78 341.9 247.28 320.07 255.63",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.62 247.3 337.12 241.21 334.86 241.01 323.62 247.3",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.21,265.71H285.39a0,0,0,0,1,0,0v68a0,0,0,0,1,0,0H128.62a0,0,0,0,1,0,0V273.31A7.6,7.6,0,0,1,136.21,265.71Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 277.51,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 282.15,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 286.8,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 291.44,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 296.09,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 300.74,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 305.38,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 310.03,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 314.67,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.62,
    y: 319.32,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.1,
    y: 265.71,
    width: 41.17,
    height: 48.96,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.18 333.76 207 333.76 232.1 314.67 273.28 314.67 248.18 333.76",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 277.51,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 282.15,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 286.8,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 291.44,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 296.09,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 300.74,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 305.38,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 310.03,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 314.67,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.74,
    y: 319.32,
    width: 19.65,
    height: 2.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.52 283.64 285.39 298.9 285.39 277.68 304.52 277.68 304.52 283.64",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.82 264.72 304.52 283.64 304.52 277.68 346.82 258.75 346.82 264.72",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.46,
    y: 427.87,
    width: 17.61,
    height: 5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,437.08a6,6,0,1,1-6-6A6,6,0,0,1,148.25,437.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.68,
    y: 427.87,
    width: 17.61,
    height: 5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.47,437.08a6,6,0,1,1-6-6A6,6,0,0,1,105.47,437.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.2,
    y: 427.87,
    width: 17.61,
    height: 5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 437.08,
    r: 5.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.93,
    y: 427.87,
    width: 17.61,
    height: 5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.74,
    cy: 437.08,
    r: 5.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.27,
    y: 207.91,
    width: 143.12,
    height: 57.8,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.27,
    y: 207.91,
    width: 143.12,
    height: 57.8,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.1 155.62 172.65 166.08 172.65 150.88 266.89 141.64 269.1 155.62",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,155.88,177,166.33V161.5l90.37-10a5.5,5.5,0,0,1,5.8,3.86Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.28,155.88,177,166.33V161.5l90.37-10a5.5,5.5,0,0,1,5.8,3.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187,148l-51.58,3.89a7.35,7.35,0,0,0-6.8,7.34v28.63h77.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.39,187.88H193.13V174.22h81.22a7.8,7.8,0,0,1,7.13,4.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.5 248.76 189.72 248.76 231 264.5 153.5 264.5 153.5 248.76",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.1,
    y: 207.91,
    width: 53.28,
    height: 56.59,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.1,
    y: 207.91,
    width: 41.17,
    height: 56.59,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,189H285.39a0,0,0,0,1,0,0v18.94a0,0,0,0,1,0,0H135a6.42,6.42,0,0,1-6.42-6.42V189A0,0,0,0,1,128.62,189Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,189H285.39a0,0,0,0,1,0,0v18.94a0,0,0,0,1,0,0H135a6.42,6.42,0,0,1-6.42-6.42V189A0,0,0,0,1,128.62,189Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.83,189h71.56a0,0,0,0,1,0,0v22.88a6.85,6.85,0,0,1-6.85,6.85H220.68a6.85,6.85,0,0,1-6.85-6.85V189A0,0,0,0,1,213.83,189Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.9,
    y: 192.17,
    width: 36.22,
    height: 20.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.97 192.17 217.9 201.43 217.9 197.25 223.97 192.17 228.97 192.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.12 209.02 254.12 212.98 249.38 212.98 254.12 209.02",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.61 192.17 217.9 208.66 217.9 207.17 235.83 192.17 237.61 192.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.12 197.68 254.12 199.16 237.61 212.98 235.84 212.98 254.12 197.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.39 192.17 217.9 195.93 217.9 195.19 221.51 192.17 222.39 192.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.12 193.73 254.12 194.47 232 212.98 231.12 212.98 254.12 193.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.12 207 254.12 207.74 247.86 212.98 246.97 212.98 254.12 207",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.41 192.17 224.54 212.98 223.66 212.98 248.53 192.17 249.41 192.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.51,
    y: 192.17,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.45,
    y: 192.17,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 192.17,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.51,
    y: 196.55,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.45,
    y: 196.55,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 196.55,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.51,
    y: 200.92,
    width: 4.29,
    height: 2.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.45,
    y: 200.92,
    width: 4.29,
    height: 2.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 200.92,
    width: 4.29,
    height: 2.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.51,
    y: 205.3,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.45,
    y: 205.3,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.4,
    y: 205.3,
    width: 4.29,
    height: 2.94,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.45,
    y: 209.67,
    width: 4.29,
    height: 2.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.03,
    y: 192.17,
    width: 6.61,
    height: 2.94,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.03,
    y: 196.55,
    width: 6.61,
    height: 2.94,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.11,78.44a23.36,23.36,0,0,1-39,14.79l-11.69,1.71,5.85-10.11a23.08,23.08,0,0,1-1.6-11.25,23.37,23.37,0,0,1,46.48,4.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.11,78.44a23.44,23.44,0,0,1-4.71,11.85,27.24,27.24,0,0,1-2.12,2.44,26,26,0,0,1-2.47,2.09,23.58,23.58,0,0,1-11.92,4.64,25.22,25.22,0,0,1-3.25.06,20.7,20.7,0,0,1-3.24-.34,23.61,23.61,0,0,1-11.56-5.71l.28.09-11.68,1.79-.85.13.43-.75,5.82-10.12,0,.4a23.65,23.65,0,0,1,1.44-20.83,23.92,23.92,0,0,1,7.32-7.79,23.52,23.52,0,0,1,10-3.75,23.33,23.33,0,0,1,19.58,6.51A23.48,23.48,0,0,1,404.11,78.44Zm0,0A23.43,23.43,0,0,0,397,59.25a22.94,22.94,0,0,0-19.41-6.09A23,23,0,0,0,368,57a24.14,24.14,0,0,0-7,7.62,23.13,23.13,0,0,0-3,9.89,23.45,23.45,0,0,0,1.65,10.18l.08.21-.11.19-5.88,10.09-.42-.62L365,92.89l.16,0,.12.11a23,23,0,0,0,11.19,5.76,19.76,19.76,0,0,0,3.17.39,22.57,22.57,0,0,0,9.44-1.38,21.82,21.82,0,0,0,5.64-3,25.31,25.31,0,0,0,2.46-2.06,27,27,0,0,0,2.13-2.41A23.44,23.44,0,0,0,404.11,78.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.14 89.34 368.16 79.24 371.51 75.92 377.34 81.83 389.45 62.84 393.43 65.37 378.14 89.34",
    style: {
      fill: "#92E3A9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterCuate);
export default __webpack_public_path__ + "static/media/Printer-cuate.302a0f9114e54f03e41b7c4e1565aeb3.svg";
export { ForwardRef as ReactComponent };